import * as __req_0 from "react-string-replace";
import React from "react";
import { Modal, Button } from "react-bootstrap";
import get from "lodash/get";
import HopCarouselIngredients from "./HopCarouselIngredients";
import "./user-action-item.scss";
import UserActionCarousel from "./UserActionsCarousel";
import SkipPairingButton from "./SkipPairingButton";
import { USER_ACTION_IDS } from "@common/constants/useractionConstants";
const reactStringReplace = (__req_0.default !== undefined ? __req_0.default : __req_0);
class UserActionModal extends React.Component {
  state = {
    index: 0,
    direction: null,
    imageloaded: false,
    showConfirmSkip: false,
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.show !== this.props.show) {
      this.setState({
        index: 0,
        direction: null,
        imageloaded: false,
        showConfirmSkip: false,
      });
    }
  }

  handleSelect = (selectedIndex, e) => {
    this.setState({
      index: selectedIndex,
      direction: e.direction,
    });
  };

  handleImageLoaded = () => {
    this.setState({ imageloaded: true });
  };

  render() {
    const {
      show,
      handleClose,
      userAction,
      resumeSession,
      stopSession,
      isBrewpack,
      preview,
      type,
    } = this.props;

    const { index, direction, imageloaded } = this.state;
    const action_steps =
      userAction && Array.isArray(userAction.action_steps)
        ? [...userAction.action_steps].sort((a, b) => a.order - b.order)
        : [];

    const step_length = action_steps.length;
    const userActionId = userAction ? userAction.user_action : 0;
    const currentstep = action_steps[this.state.index] || null;

    const replaceFunction = (match, index) => {
      index;
      const splitString = match.split("|");
      const text = splitString[0];
      const link = splitString[1];
      return (
        <a href={link} target="_blank" rel="noopener noreferrer">
          {text}
        </a>
      );
    };
    return (
      <div>
        <Modal
          show={show}
          onHide={handleClose}
          className="useraction__modal"
          bsSize={this.state.showConfirmSkip ? undefined : "large"}
          scrollable
        >
          {this.state.showConfirmSkip ? (
            <>
              <Modal.Header closeButton>
                <Modal.Title
                  style={{
                    textAlign: "center",
                    fontFamily: "Gotham-Bold",
                    fontWeight: "normal",
                  }}
                >
                  Skip setup?
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div
                  style={{
                    padding: "30px 20px",
                    fontSize: "16px",
                    fontFamily: "Gotham-Book",
                    textAlign: "center",
                  }}
                >
                  Ensure all physical setup (hoses, yeast, CIP) is done.
                  Skipping steps can damage the machine or ruin your batch.
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  onClick={() => this.setState({ showConfirmSkip: false })}
                >
                  Cancel
                </Button>
                <Button
                  onClick={() => {
                    this.setState({ showConfirmSkip: false });
                    const action =
                      this.props.stopSession || this.props.resumeSession;
                    if (action) {
                      action();
                    }
                  }}
                  bsStyle="primary"
                >
                  Yes, skip setup
                </Button>
              </Modal.Footer>
            </>
          ) : (
            <>
              <Modal.Header closeButton>
                <Modal.Title
                  style={{
                    textAlign: "center",
                    fontFamily: "Gotham-Bold",
                    fontWeight: "normal",
                  }}
                >
                  {!this.state.imageloaded && "Loading useraction..."}
                  {type
                    ? `${type} Instruction`
                    : this.props.userAction && get(currentstep, "title")}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body scrollable={true}>
                <div className="container-fluid ">
                  <div className="row">
                    <div
                      className="col-md-8 col-xs-12"
                      style={{ padding: "0" }}
                    >
                      {userAction && (
                        <UserActionCarousel
                          userAction={{ ...userAction, action_steps }}
                          handleSelect={this.handleSelect}
                          index={index}
                          direction={direction}
                          handleImageLoaded={this.handleImageLoaded}
                          style={{ visibility: imageloaded ? "" : "hidden" }}
                        />
                      )}
                    </div>
                    <div
                      className="col-md-4 instruction-text-container"
                      style={{ marginTop: "20px" }}
                    >
                      <div className="instruction-text">
                        Step:{" "}
                        {step_length > 0
                          ? `${index + 1}/${step_length}`
                          : "1/1"}
                        <p
                          style={{
                            fontFamily: "Gotham-Book",
                            whiteSpace: "pre-wrap",
                          }}
                        >
                          {reactStringReplace(
                            (currentstep && currentstep.description) ||
                              (userAction && userAction.description) ||
                              (userAction && userAction.title) ||
                              "",
                            /{{(.*?)}}/,
                            replaceFunction,
                          )}
                        </p>
                        {/* USERACTION FILL HOP CAROUSELL */}
                        {userActionId == 20 &&
                          currentstep &&
                          currentstep.id == 27 &&
                          !isBrewpack && <HopCarouselIngredients />}
                      </div>
                    </div>
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer>
                {!this.state.imageloaded && (
                  <div
                    className="useraction-modal__loading-row"
                    style={{
                      textAlign: "left",
                      color: "#888",
                      fontSize: "13px",
                      marginBottom: "12px",
                      clear: "both",
                    }}
                  >
                    <span
                      className="start-brew-loading__icon ion-load-c spin"
                      style={{ marginRight: "8px", fontSize: "16px" }}
                    />
                    Fetching useraction...
                  </div>
                )}
                <div>
                  {!preview && (
                    <>
                      {/* USERACTION PAIR GRAVITY SENSOR */}
                      {userActionId ==
                        USER_ACTION_IDS.ACTION_PAIR_GRAVITY_SENSOR &&
                        index == 0 && (
                          <SkipPairingButton
                            action={stopSession || resumeSession}
                          />
                        )}
                      {userActionId !==
                        USER_ACTION_IDS.ACTION_PAIR_GRAVITY_SENSOR &&
                        step_length > 1 &&
                        this.state.index < step_length - 1 && (
                          <Button
                            onClick={() =>
                              this.setState({ showConfirmSkip: true })
                            }
                            style={{ float: "left", marginRight: "8px" }}
                            bsStyle="info"
                          >
                            Skip Setup
                          </Button>
                        )}
                    </>
                  )}

                  <Button
                    onClick={() =>
                      this.handleSelect(this.state.index - 1, {
                        direction: "prev",
                      })
                    }
                    disabled={this.state.index == 0}
                  >
                    <span className="ion-chevron-left" /> Previous
                  </Button>
                  {this.state.index < step_length - 1 && (
                    <Button
                      onClick={() =>
                        this.handleSelect(this.state.index + 1, {
                          direction: "next",
                        })
                      }
                    >
                      Next <span className="ion-chevron-right" />
                    </Button>
                  )}

                  {
                    // On click, we should stop session if that fn
                    // is present, otherwise just resume it.
                    (step_length <= 1 || this.state.index >= step_length - 1) &&
                      userActionId !==
                        USER_ACTION_IDS.ACTION_PAIR_GRAVITY_SENSOR &&
                      !preview && (
                        <Button
                          onClick={stopSession || resumeSession}
                          bsStyle="primary"
                        >
                          Continue
                        </Button>
                      )
                  }
                </div>
              </Modal.Footer>
            </>
          )}
        </Modal>
      </div>
    );
  }
}

export default UserActionModal;
